import { render } from "./SelectorReceptores.vue?vue&type=template&id=66f45666&scoped=true"
import script from "./SelectorReceptores.vue?vue&type=script&lang=js"
export * from "./SelectorReceptores.vue?vue&type=script&lang=js"

import "./SelectorReceptores.vue?vue&type=style&index=0&id=66f45666&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f45666"]])

export default __exports__